import React from "react";
import {Dropdown} from "react-bootstrap";

export function TagDropdown({selectCallback, tags, className}) {

    return (
        <div className={"row "+className}>
            <Dropdown className={"col"}>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic" className={"w-100 text-dark"}>
                   Add tag
                </Dropdown.Toggle>
                <Dropdown.Menu className={"w-100"}>
                    {
                        tags.map(tag => (
                            <Dropdown.Item onClick={() => selectCallback(tag)}>{tag.text}</Dropdown.Item>
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );

}